"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PsqHelper = void 0;
var constants = require("./Constants");
var PsqHelper = (function () {
    function PsqHelper() {
    }
    PsqHelper.getLabel = function (psq) { return "" + psq.text + (psq.isRequired ? constants.ASTERISK : ''); };
    return PsqHelper;
}());
exports.PsqHelper = PsqHelper;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/shared/code/PsqHelper.ts
// module id = 74
// module chunks = 0